import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { UserContext } from '../../../Context/UserContext.js';
import * as Yup from 'yup';
import style from "./AddProfile.module.css"
import { toast } from 'react-toastify';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import Cropper from 'react-easy-crop';
import { CompanyContext } from '../../../Context/CompanyContext.js';



export default function AddProfile({ fetchData }) {
   const [values, setValues] = useState({});
   const [listTest, setListTest] = useState([]);
   const [listTestName, setListTestName] = useState([]);
   const [search, setSearch] = useState([]);
   const [company, setCompany] = useState("");
   const testInputRef = useRef();
   const companyInputRef = useRef();






   const [loading, setLoading] = useState(false);
   const closeBtnRef = useRef();
   const { userToken } = useContext(UserContext);

   const [imageSrc, setImageSrc] = useState(null);
   const [crop, setCrop] = useState({ x: 0, y: 0 });
   const [zoom, setZoom] = useState(1);
   const [croppedArea, setCroppedArea] = useState(null);
   const { getAllCompanyInfo, allCompanyInfo } = useContext(CompanyContext);




   const onCropComplete = (_, croppedAreaPixels) => {
      setCroppedArea(croppedAreaPixels);
   };

   const handleFileChange = (e, setFieldValue) => {
      const file = e.target.files[0];
      if (!file) return;

      setFieldValue("file", file);
      const reader = new FileReader();
      reader.onload = () => setImageSrc(reader.result);
      reader.readAsDataURL(file);
   };

   const cropImage = async (imageSrc, croppedArea) => {
      const img = new Image();
      img.src = imageSrc;
      await new Promise((r) => (img.onload = r));

      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(img, 0, 0);

      return new Promise((resolve) =>
         canvas.toBlob(resolve, "image/jpeg")
      );
   };




   const handleSubmit = async (values, { setSubmitting }) => {
      try {
         const croppedBlob = await cropImage(imageSrc, croppedArea);
         const formData = new FormData();
         formData.append("name", values.name);
         formData.append("description", values.description);
         formData.append("discount", values.discount);

         listTest.forEach(id => {
            formData.append("listIdTest[]", id);
         });
         formData.append("company", company);
         formData.append("file", croppedBlob, "cropped.jpg");

         const headers = {
            'enctype': 'multipart/form-data',
            token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
         };
         const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/profile`, formData, { headers });
         if (data.message === "success") {
            toast.success("Successfully Added Profile");
            closeBtnRef.current.click();
            fetchData();
         }
      } catch (err) {
         toast.error(err.response?.data?.message || "Error while uploading");
      }

      setSubmitting(false);
   };

   const initialValues = {
      name: "",
      description: "",
      discount: "",
      file: null,
   }

   const validationSchema = Yup.object().shape({
      name: Yup.string().required("اسم البروفايل مطلوب"),
      description: Yup.string().required("الوصف مطلوب"),
      discount: Yup.number().required("الخصم مطلوب"),
      file: Yup.mixed().required("الصورة مطلوبة")
   });




   //^=============================================
   //& Search Test By Test Name :
   function searchInput(e) {
      if (e.target.value === "") {
         setSearch([])
      }
      if (e.target.value.length >= 3) {
         getSearchData((e.target.value).toLowerCase())
      }
   }
   //& Get All test And Search On Test By Test Name :
   async function getSearchData(search) {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/test?keyword=${search}`)
         .then(({ data }) => {
            if (data.message === "success") {
               setSearch(data.tests)
            }
         })
         .catch((error) => {
            console.log(error.response.data.message)
         })
   }
   //& Search Test By Test Name :
   function addTestToList(id, name) {
      if (listTest.find((ele) => ele === id)) {
         return;
      }
      setValues(prev => ({ ...prev, listIdTest: [...(prev.listIdTest || []), id] }));
      setListTest([...listTest, id])
      setListTestName([...listTestName, { id, name }])
      setSearch([])
   }
   const deleteTest = (test) => {
      setValues(prev => ({ ...prev, listIdTest: prev.listIdTest.filter(id => id !== test.id) }));
      setListTestName(prevTest => prevTest.filter(ele => ele.name !== test.name));
   };
   //^=============================================


   useEffect(() => {
      getAllCompanyInfo()
   }, [])
   return (
      <Fragment>
         <div className='container'>
            <div dir='rtl' className="modal fade" id="AddProfile" tabIndex="-1" aria-labelledby="AddProfileLabel" aria-hidden="true">
               <div className="modal-dialog">
                  <div className="modal-content">

                     <div className="d-flex justify-content-between align-items-center p-3">
                        <h5 dir='rtl' className="modal-title" id="AddProfileLabel">أضافة بروفايل جديد</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                     </div>

                     <div className="modal-body">
                        <div className="">
                           <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                              {({ setFieldValue, isSubmitting }) => (
                                 <Form className="m-auto">
                                    <div className="mb-3">
                                       <label htmlFor='name'>اسم البروفايل</label>
                                       <Field type="text" name="name" id='name' className="form-control" />
                                       <ErrorMessage name="name" component="div" className="text-danger" />
                                    </div>

                                    <div className="mb-3">
                                       <label htmlFor='description'>الوصف</label>
                                       <Field as="textarea" id="description" name="description" placeholder="اكتب وصف البروفايل" rows="5" className="form-control" />
                                       <ErrorMessage name="description" component="div" className="text-danger" />
                                    </div>

                                    <div className="mb-3">
                                       <label htmlFor='discount'> نسبة الخصم  %</label>
                                       <Field type="number" name="discount" id='discount' className="form-control" />
                                       <ErrorMessage name="discount" component="div" className="text-danger" />
                                    </div>

                                    {/* <div className="mb-3">
                                       <label htmlFor='company'>company</label>
                                       <select name="company" id='company' className="form-control" >
                                          <option value="1">1</option>
                                          <option value="2">2</option>
                                          <option value="3">3</option>
                                       </select>
                                       <ErrorMessage name="company" component="div" className="text-danger" />
                                    </div> */}



                                    <div className="my-2">
                                       <label htmlFor="company" className="form-label">اختار مقدم الخدمة</label>
                                       <select ref={companyInputRef} name="company" id="company" className="form-control" onChange={(e) => { setCompany(e.target.value) }}>
                                          <option value="">اختيار مقدم الخدمة</option>
                                          {allCompanyInfo.length > 0 ?
                                             allCompanyInfo.map((ele) =>
                                                <option value={ele._id}>{ele.name}</option>
                                             )
                                             :
                                             ""
                                          }
                                       </select>
                                    </div>



                                    <div className='my-2'>
                                       <form >
                                          <label htmlFor="test" className="form-label">اختار  الخدمات </label>
                                          <input ref={testInputRef} type="search" onChange={(e) => { searchInput(e) }} className='form-control' id='test' placeholder='أضافة  خدمات ' name="search" />
                                       </form>

                                       {search.length ?
                                          <div className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-2 overflow-auto `}>
                                             {search.map((ele) => <p key={ele._id} onClick={() => addTestToList(ele._id, ele.name)} className='bg-white border rounded-1 p-1 ps-2 fw-bold m-0 my-1 text-success cursor'>{ele.name}</p>)}
                                          </div>
                                          : ""
                                       }


                                       <div className='container'>
                                          {listTestName.map((ele) =>
                                             <div key={ele.name} className='bg-body-secondary rounded-3'>
                                                <div className='d-flex justify-content-between px-2 my-1  bg-body-tertiary rounded-3'>
                                                   <i onClick={() => { deleteTest(ele) }} className="fa-solid fa-trash text-danger btn"></i>
                                                   <p className='text-center p-0 m-0'>{ele.name}</p>
                                                </div>
                                             </div>
                                          )}
                                       </div>
                                    </div>


                                    <div className="mb-3">
                                       <label htmlFor='image'>الصورة</label>
                                       <input type="file" accept="image/*" id='image' className="form-control" onChange={(e) => handleFileChange(e, setFieldValue)} />
                                       <ErrorMessage name="file" component="div" className="text-danger" />
                                    </div>

                                    {imageSrc && (
                                       <div className="mb-3 border border-2" style={{ width: 300 }}>
                                          <img
                                             src={imageSrc}
                                             alt="preview"
                                             style={{ maxWidth: "100%", height: "auto" }}
                                          />
                                       </div>
                                    )}

                                    <div className="text-center mt-4">
                                       <button type="submit" disabled={isSubmitting} className="btn bg-main w-50">
                                          {isSubmitting ? <i className="fa fa-spinner fa-spin"></i> : "إضافة"}
                                       </button>

                                       {/* {loading? 
                                          <button className='btn bg-main btn-sm m-2'> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button> 
                                          : 
                                          <button type='submit' className='btn btn-new-color btn-sm m-2'>اتمام الطلب</button>
                                       } */}
                                    </div>
                                 </Form>
                              )}
                           </Formik>
                        </div>
                     </div>

                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
}
